import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';
import { GoogleAuthService, GoogleUser } from '../../../services/google-auth.service';

@Component({
  selector: 'app-blog-header',
  standalone: true,
  imports: [CommonModule, RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <header class="bh">
      <div class="bh__inner">
        <a class="bh__brand" routerLink="/home" aria-label="MindmapsforUPSC home">
          <img src="assets/mindmaps.png" alt="" class="bh__logo">
          <span class="bh__name">MindmapsforUPSC</span>
        </a>

        <div class="bh__spacer"></div>

        <ng-content></ng-content>

        <div class="bh__user" *ngIf="user">
          <img *ngIf="user.picture" [src]="user.picture" alt="" class="bh__avatar">
          <span class="bh__email">{{ user.email }}</span>
        </div>
      </div>
    </header>
  `,
  styleUrls: ['./blog-header.component.css'],
})
export class BlogHeaderComponent implements OnInit, OnDestroy {
  user: GoogleUser | null = null;
  private sub?: Subscription;
  private auth = inject(GoogleAuthService);

  ngOnInit(): void {
    this.sub = this.auth.user$.subscribe(u => (this.user = u));
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
